<div class="p-3 pt-2 rounded-4">
  <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
    <div class="p-3">Reconciliation</div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-3 mt-4">
        <label class="required">From Date</label>
        <div class="input-group">
          <input class="form-control" name="frmDate" required [(ngModel)]="fromDate" autocomplete="off"
            ngbDatepicker (ngModelChange)="onFromDate($event)" #d1="ngbDatepicker" placeholder="From Date">
          <span class="input-group-text pointer" (click)="d1.toggle()">
            <i class="bi bi-calendar"></i>
          </span>
        </div>
      </div>
      <div class="col-md-3 mt-4">
        <label class="required">To Date</label>
        <div class="input-group">
          <input class="form-control" name="toDate" required [(ngModel)]="toDate" autocomplete="off"
            ngbDatepicker #d2="ngbDatepicker" [minDate]="minStart" placeholder="To Date">
          <span class="input-group-text pointer" (click)="d2.toggle()">
            <i class="bi bi-calendar"></i>
          </span>
        </div>
      </div>
      <div class="col-md-3 mt-4">
        <div class="form-group">
          <label class="required">Type</label>
          <select class="form-control form-select" name="pType" #pType="ngModel" [(ngModel)]="type" required>
            <option value="Andaria">Andaria</option>
            <option value="HNB">HNB</option>
          </select>
        </div>
      </div>
      <div class="col-md-3 mt-5">
        <div class="d-flex">
          <div class="">
            <input class="d-none" type="file" #fileInput accept=".xlsx" (change)="uploadExcel($event)" />
            <button class="btn btn-outline-primary" (click)="fileInput.click()">
              <i class="bi bi-upload"></i>
            </button>
            @if (excelFile) {
              <span class="ms-2 text-muted small">{{ excelFile.name }}</span>
            }
          </div>
          <div class="ms-2">
            <button class="btn btn-success btn-sm ms-2 me-2"
              [disabled]="!fromDate || !toDate || !type || !excelFile"
            (click)="onSubmit()">Submit</button>
            <button class="btn btn-danger btn-sm"
            (click)="onClear()">Clear</button>
          </div>
        </div>
        @if (errorMessage) {
          <div class="mt-2 text-danger small">{{ errorMessage }}</div>
        }
      </div>
    </div>
  </div>
  <div class="container-fluid">
    @if (reconciliationData) {
      <div class="row bg-white p-2 pt-0">
        @if (!reconciliationData.invalidExcelRecords || reconciliationData.invalidExcelRecords.length === 0) {
          <div class="col-12 mt-4">
            <div class="alert alert-success">All uploaded records match the ledger records. No discrepancies found.</div>
          </div>
        }
        <div class="col-md-3">
          <div class="card card-success rounded p-3 p-xxl-4 mt-4">
            <div class="card-body border-start border-success border-3 pt-0 pb-0">
              <div class="d-flex flex-column justify-content-center align-items-center">
                <div class="fs-1 fw-bold">{{reconciliationData.totalExcelRecords}}</div>
                <div>Total Excel Records</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-total rounded p-3 p-xxl-4 mt-4">
            <div class="card-body border-start border-primary border-3 pt-0 pb-0">
              <div class="d-flex flex-column justify-content-center align-items-center">
                <div class="fs-1 fw-bold">{{reconciliationData.totalLedgerRecords}}</div>
                <div>Total Ledger Records</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-refund rounded p-3 p-xxl-4 mt-4">
            <div class="card-body border-start border-warning border-3 pt-0 pb-0">
              <div class="d-flex flex-column justify-content-center align-items-center">
                <div class="fs-1 fw-bold">{{reconciliationData.validExcelRecords}}</div>
                <div>Valid Excel Records</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-info rounded p-3 p-xxl-4 mt-4">
            <div class="card-body border-start border-info border-3 pt-0 pb-0">
              <div class="d-flex flex-column justify-content-center align-items-center">
                <div class="fs-1 fw-bold">{{reconciliationData.validLedgerRecords}}</div>
                <div>Valid Ledger Records</div>
              </div>
            </div>
          </div>
        </div>
        @if (reconciliationData?.invalidExcelRecords?.length) {
          <div class="col-12 mt-4">
            <h5 class="mb-3">
              Invalid Excel Records ({{ reconciliationData.invalidExcelRecords.length }})
            </h5>
            <div class="table-responsive">
              <table class="table table-bordered table-striped align-middle">
                <thead class="table-light">
                  <tr>
                    <th>Transaction Id</th>
                    <th>Type</th>
                    <th>Source Bank</th>
                    <th>Source Account</th>
                    <th>Destination Bank</th>
                    <th>Destination Account</th>
                    <th>Currency</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of reconciliationData.invalidExcelRecords; track item; let i = $index) {
                    <tr>
                      <td>{{ item.record['Transaction Id'] }}</td>
                      <td>{{ item.record.Type }}</td>
                      <td>{{ item.record.Source_Bank }}</td>
                      <td>{{ item.record.Source_Account }}</td>
                      <td>{{ item.record.Destination_Bank }}</td>
                      <td>{{ item.record.Destination_Account }}</td>
                      <td>{{ item.record.Currency }}</td>
                      <td>{{ item.record.Amount }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>